import reportReducer from './report.reducer'

export default reportReducer